export default __webpack_public_path__ + "images/73171fb9b5e2905edb44f24a8a607269.svg";